exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*---------------\r\n3.3 App Variables\r\n---------------*/\n/*$custom-typography: mat-typography-config($font-family: $mat-font-family);\r\n@include mat-core($custom-typography);*/\n.form-bg {\n  padding: 0 20px; }\n.form-bg .logo {\n    /* margin-bottom: 30px; */\n    text-align: center;\n    background: #706F6F;\n    border-radius: 10px 10px 0 0;\n    padding: 15px 0; }\n.form-bg .logo img {\n      width: 100%;\n      max-width: 220px; }\n.form-bg .mat-input-element {\n    font-size: 16px; }\n.form-bg .btn-wrapper {\n    text-align: center; }\n.form-bg .forgot-link {\n    color: #706F6F;\n    font-size: 12px;\n    text-decoration: underline; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/session/login/login-component.scss
// module id = ../../../../../src/app/session/login/login-component.scss
// module chunks = session.module